import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const DEFAULT_BACKGROUND_ID = 'none';

interface BackgroundState {
  selectedBackgroundId: string;
}

const initialState: BackgroundState = {
  selectedBackgroundId: DEFAULT_BACKGROUND_ID,
};

const backgroundSlice = createSlice({
  name: 'background',
  initialState,
  reducers: {
    setSelectedBackground: (state, action: PayloadAction<string>) => {
      state.selectedBackgroundId = action.payload;
    },
  },
});

export const { setSelectedBackground } = backgroundSlice.actions;
export default backgroundSlice.reducer;
